
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {

    display: flex;

    justify-content: center
}

.idb-form-confirmation-page {

    max-width: 56rem;

    border-radius: 0.5rem;

    background-color: var(--blue-responsible-lighten-4);

    padding-top: 2rem;

    padding-bottom: 2rem;

    padding-left: 4rem;

    padding-right: 4rem;

    text-align: center
}

outline-icon {

    display: flex;

    justify-content: center;

    color: var(--green-guarantee-main)
}

idb-heading {

    padding-top: 2rem;

    padding-bottom: 2rem
}

.container-buttons {

    margin-top: 3.5rem;

    margin-bottom: 3.5rem;

    display: flex;

    flex-wrap: wrap;

    justify-content: space-around;

    gap: 1.5rem
}

@media (min-width: 1024px) {

    .container-buttons {

        margin-top: 5rem;

        margin-bottom: 5rem
    }

    .container-buttons {

        flex: 1 1 auto
    }

    .container-buttons {

        gap: 0px
    }
}
`;